module.exports = __webpack_public_path__ + "img/Angiogenesis-BRME_GSE179572.d40f2154.png";